import {Container, Col, Row }from 'react-bootstrap';

import { useState } from 'react';

import Header from '../sections/header';
import Footer from '../sections/footer';
import MainContent from '../sections/maincontent';
import SmallInfoCard from '../gridspaces/SmallInfoCard';

import ImageScroller from '../gridspaces/ImageScroller';

import CapeTownProjectText from '../content/CapetownProjectText';
import ContentBDELaunchText from '../content/BDELaunchText';
import ContentBDEFoundingText from '../content/BDEFoundingtext';
import ContentNDRCProjectText from '../content/NDRCProjectText';
import ContentGDProjectText from '../content/GraphicDesignProjectText';


function PageProjects(){
    let [projectcapetown, setProjectCapeTown] = useState(false);
    //let [projecthydrapouch, setProjectHydraPouch] = useState(false);
    let [projectcoldplunge, setProjectColdPlunge] = useState(false);
    let [projectbde, setProjectBDE] = useState(false);
    let [projectbdeweb, setProjectBDEWeb] = useState(false);
    let [projectndrc, setProjectNDRC] = useState(false);
    let [projectgraphicdesign, setProjectGraphicDesign] = useState(false);

    const CollapseAll = () => {
        setProjectBDE(false);
        setProjectBDEWeb(false);
        setProjectCapeTown(false);
        setProjectColdPlunge(false);
        setProjectNDRC(false);
        setProjectGraphicDesign(false);
    }
    /*const TogglepHP = () => {
        CollapseAll();
        setProjectHydraPouch(true);
    }*/
    const TogglepCapeTown = () => {
        CollapseAll();
        setProjectCapeTown(true);
    }
    const TogglepCP = () => {
        CollapseAll();
        setProjectColdPlunge(true);
    }
    const TogglepBDE = () => {
        CollapseAll();
        setProjectBDE(true);
    }
    const TogglepBDEWeb = () => {
        CollapseAll();
        setProjectBDEWeb(true);
    }

    const ToggleGraphicDesign = () => {
        CollapseAll();
        setProjectGraphicDesign(true);
    }

    const ToggleNDRC = () => {
        CollapseAll();
        setProjectNDRC(true);
    }

    return (
        <> 
            <Header />
            <Container fluid className="color-bg-secondary">
            <MainContent additionalstyle="color-bg-secondary">
                
                <Row>
                    <Col md={{span:2}}>
                        <Container>
                            <Row>
                                <SmallInfoCard title='Cape Town Course Review' subtitle='2026, May 24 - Before it was a major.' action={TogglepCapeTown} />
                                <SmallInfoCard title='Big Distance Energy Web Launch' subtitle='2026, Jan 24' action={TogglepBDEWeb} />
                                <SmallInfoCard title='Cold Plunge 1.0' subtitle='2024-06-02' action={TogglepCP} />
                                <SmallInfoCard title='Big Distance Energy Creative Founding' subtitle='2024, Jan 24' action={TogglepBDE} />
                                <SmallInfoCard title='Graphic Design Forray' subtitle='2024, Apr 3' action={ToggleGraphicDesign} />
                                <SmallInfoCard title='Not Dallas Run Club' subtitle='2020, Aug 13' action={ToggleNDRC} />
                            </Row>
                        </Container>
                    </Col>
                    <Col md={{span:10}}>
                        
                        { projectcoldplunge &&
                            <Container>
                                <Row>
                                    <ImageScroller images={["/assets/coldplunge/cpcover.jpg","/assets/coldplunge/5410.jpg","/assets/coldplunge/0161.jpg","/assets/coldplunge/5145.jpg"]} />
                                </Row>
                                <Row>
                                    <p className="py-0 text-start font-body color-font-primary font-size-large">Growing the recovery toolbox</p>
                                    <p className="py-0 text-start font-body color-font-primary font-size-small">Cold plunging was a craze that swept through the fitness community and got a foothold in the social media space. Even though trends can gather widespread popularity and acceptance, the results may vary or be fudged. So, I had to see for myself if this was something I could benefit from.</p>
                                </Row>
                                <Row>
                                    <p className="py-0 text-start font-body color-font-primary font-size-small">
                                    My first times cold plunging yielded benefits very early on. Aches and pains from marathon training were winning the battle. There are only so many hours in a day—if a certain amount of time is spent training, then a certain amount of time must be spent recovering. One of the ideas in training is being more efficient and effective with your timing. I believe, as an athlete, you should also be efficient and effective with the time you spent recovering. For instance, if you're dedicating X hours to sleep, Y hours to other passive recovery methods, and Z hours to active recovery methods, how do you get the most out of each? I found one of the answers to be cold plunging. It helped me deal with swelling and got me to relaxed meditative states.</p>

                                </Row>
                                <Row>
                                    <p className="py-0 text-start font-body color-font-primary font-size-small">
                                        I started out using a local wellness and recovery company’s cold plunging service, which enabled me to run longer and train harder—which meant that I needed to plunge more to mitigate the wear and tear before an injury sidelined me. This had the potential to be very expensive, but the cost-benefit ratio was still in a good place so far. This prompted the thought "why don't I just do it myself?" If I can plunge as much as I wanted whenever I wanted for however long I wanted, I thought I could squeeze more of a benefit from the equation. So, based on what I knew about the process and with a little additional research, I built my own fully functional cold plunge. And my friends let me test it out on them—or used the fact that I had it to their advantage.</p>

                                </Row>
                            </Container>
                        }
                        { projectbde &&
                            <Container>
                                <Row>
                                    <ContentBDEFoundingText />
                                </Row>
                            
                            </Container>
                        }
                        { projectcapetown &&
                            <Container>
                                <Row>
                                    <ImageScroller images={["/assets/capetown/ctmedal.jpg","/assets/capetown/ctviews.jpg","/assets/capetown/ctcoursemap.jpg", "/assets/capetown/ctcarsigning.jpg","/assets/capetown/ctviews2.jpg","/assets/capetown/ctelevationmap.jpg","/assets/capetown/ctsplits.jpg","/assets/capetown/ctpose.jpg"]} />
                                </Row>
                                <Row>
                                    <CapeTownProjectText />
                                </Row>
                            
                            </Container>
                        }

                        { projectbdeweb &&
                            <Container>
                                <Row>
                                    <ContentBDELaunchText />
                                </Row>
                            
                            </Container>
                        }
                        { projectgraphicdesign &&
                            <Container>
                                <Row>
                                    <ImageScroller images={["/assets/headties/blackandwhiteht.png","/assets/headties/blackht.png","/assets/headties/whiteht.png"]} />
                                </Row>
                                <Row>
                                    <ContentGDProjectText />
                                </Row>
                            
                            </Container>
                        }
                        { projectndrc &&
                            <Container>
                                <Row>
                                    <ImageScroller images={["/assets/hoodies/maroonhoodie2.jpg","/assets/hoodies/greenhoodie.jpg","/assets/hoodies/2079.png","/assets/hoodies/2075.png","/assets/hoodies/2074.jpg","/assets/hoodies/2073.png","/assets/hoodies/2072.jpg"]} />
                                </Row>
                                <Row>
                                    <ContentNDRCProjectText />
                                </Row>
                            
                            </Container>
                        }
                    </Col>
                </Row>
            </MainContent>
            </Container>
            <Footer />
        </>
    )
}

export default PageProjects;